import { GutterSeparator } from "@qw/ui";
import { partition } from "lodash";
import { Fragment, useMemo } from "react";
import { useInboxFilter } from "@/providers/inbox-filter-provider";
import { useConversations } from "@/providers/use-conversations";
import { ConversationLink } from "./conversation-link";

export const InboxGroups = () => {
  const { conversations } = useConversations();
  const { priorityLabels } = useInboxFilter();

  const allConversations = useMemo(() => {
    const [priority, nonPriority] = partition(conversations, (conversation) =>
      priorityLabels.some((label) => conversation.labels.includes(label))
    );

    // Sort priority conversations by their first matching label order
    const sortedPriority = priority.sort((a, b) => {
      const aLabelIndex = priorityLabels.findIndex((label) => a.labels.includes(label));
      const bLabelIndex = priorityLabels.findIndex((label) => b.labels.includes(label));
      return aLabelIndex - bLabelIndex;
    });

    return [...sortedPriority, ...nonPriority];
  }, [conversations, priorityLabels]);

  return (
    <>
      {allConversations.map((conversation) => (
        <Fragment key={conversation.id}>
          <ConversationLink conversation={conversation} />
          <GutterSeparator />
        </Fragment>
      ))}
    </>
  );
};
